export const inputCls =
  "w-full rounded-xl border border-corduroy bg-ink px-4 py-3 text-sm text-cream placeholder:text-latte/50 outline-none transition-colors focus:border-gold";

export const btnPrimary =
  "rounded-full bg-ember px-6 py-3 text-sm font-bold text-ink transition-colors hover:bg-neon hover:text-cream disabled:opacity-60";

export const btnGhost =
  "rounded-full border border-corduroy px-5 py-2.5 text-sm font-semibold text-cream transition-colors hover:border-gold hover:text-gold";

export const Field = ({ label, children, className = "" }) => (
  <label className={`block ${className}`}>
    <span className="text-xs font-semibold uppercase tracking-[0.2em] text-latte">
      {label}
    </span>
    <div className="mt-2">{children}</div>
  </label>
);
